import { useState, useCallback, useMemo } from "react";
import { ANONYMOUS_SESSION_PLAN_INFO } from "@jugl-web/utils/storage";
import { useSessionStorage } from "@jugl-web/utils/hooks/useStorage";
import { CXSignupDialogContext } from "./CXSignupDialogContext";
import { CXSignupDialog } from "./CXSignupDialog";
import { SelectedPlanInfo } from "../CompletePurchaseDialog/components/SummaryStep/types";

export const CXSignupDialogProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isForced, setIsForced] = useState(false);
  const [, setSelectedPlan] = useSessionStorage<SelectedPlanInfo | undefined>(
    ANONYMOUS_SESSION_PLAN_INFO,
    undefined
  );

  const open = useCallback((options?: { forced?: boolean }) => {
    setIsOpen(true);
    setIsForced(!!options?.forced);
  }, []);

  const close = useCallback(() => {
    if (isForced) return;
    setIsOpen(false);
    setIsForced(false);
    setSelectedPlan(undefined);
  }, [isForced, setSelectedPlan]);

  const contextValue = useMemo(
    () => ({
      open,
      close,
      isOpen,
      isForced,
    }),
    [open, close, isOpen, isForced]
  );

  return (
    <CXSignupDialogContext.Provider value={contextValue}>
      <CXSignupDialog
        isOpen={isOpen}
        isForced={isForced}
        onRequestClose={close}
      />
      {children}
    </CXSignupDialogContext.Provider>
  );
};
